import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63d9eaa1"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href", "target"]
const _hoisted_2 = ["type", "disabled"]

import {
  mapModifires,
  mergeModifires,
  type typeModifires,
} from "@/components/utils/modifires";
import { withDefaults, defineOptions } from "vue";

interface Props {
  modifires?: typeModifires;
  href?: string;
  to?: string;
  target?: "_self" | "_blank" | "_parent" | "_top";
  type?: "button" | "submit" | "reset";
  size?: "ml" | "l";
  disabled?: boolean;
  negative?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'button-item',
  props: {
    modifires: { type: [String, Array, Boolean] },
    href: {},
    to: {},
    target: {},
    type: { default: "button" },
    size: {},
    disabled: { type: Boolean },
    negative: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit }) {

const props = __props;






const handleClick = (e: Event) => {
  if (!props.disabled) {
    emit("click", e);
  }
};

const componentClass = () =>
  mapModifires(
    "button-item",
    mergeModifires(props.modifires, props.size && `size-${props.size}`)
  );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(componentClass())
  }, [
    (_ctx.href)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          onClick: handleClick,
          class: "button-item__btn",
          href: _ctx.href,
          target: _ctx.target
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["button-item__inner", { 'button-item__inner-negative': _ctx.negative && !_ctx.disabled }])
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["button-item__txt", { 'button-item__txt-negative': _ctx.negative && !_ctx.disabled }])
            }, [
              _renderSlot(_ctx.$slots, "default")
            ], 2)
          ], 2)
        ], 8, _hoisted_1))
      : (_openBlock(), _createElementBlock("button", {
          key: 1,
          onClick: handleClick,
          class: "button-item__btn",
          type: _ctx.type,
          disabled: props.disabled
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["button-item__inner", { 'button-item__inner-negative': _ctx.negative && !_ctx.disabled }])
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["button-item__txt", {
            'button-item__ml-txt': props.size == 'ml',
            'button-item__txt-negative': _ctx.negative && !_ctx.disabled,
          }])
            }, [
              _renderSlot(_ctx.$slots, "default")
            ], 2)
          ], 2)
        ], 8, _hoisted_2))
  ], 2))
}
}

})